// removed by extract-text-webpack-plugin
module.exports = {"block":"_2FGWpLJu7wZtmgEgj2j6aH","container":"_14DAt1-tACZmobHJv8oX6_","no-logo":"_2ttsdZ60Tm1TmH7AEeQQWS","logo-container":"_2K0lNcywMYH9CYOHUdEZIe","logo":"_3UfI2nHJV6nhK8KfWld821","text-container":"_7WMPuDAiWdUs27Su-dP3d","name":"_2i7sgp-gmYQ6ht-jtAirxq","container-no-logo":"f4fM-kAUqu0f8t6xCfJU8","button":"_398m38GtQw7amTNeMmr-My"};


//////////////////
// WEBPACK FOOTER
// ./src/components/VisitOurWebsiteBlock/VisitOurWebsiteBlock.module.scss
// module id = 818
// module chunks = 0